
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
	components: {
		//
	}
})
export default class EmailDialog extends Vue {
	@Prop({ required: true })
	editorOpen!: boolean

	@Prop({ required: false, default: '' })
	title!: string

	@Prop({ required: false, default: 1 })
	itemCount!: number

	@Prop({ required: false, default: null })
	sendButtonText!: string

	@Prop({ required: false, default: false })
	sending!: boolean

	async send() {
		this.$emit('send')
	}
}
